import clsx from "clsx";
import { IoCloseSharp } from "react-icons/io5";
import { motion } from "framer-motion";

export const FullModal = ({
  children,
  onClose,
  showCloseIcon,
  className,
  iconClass,
}) => {
  return (
    <>
      {/* Backdrop with fade animation */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 z-[3999] 480:max-w-[440px] 480:mx-auto bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal with slide animation */}
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{
          type: "tween",
          duration: 0.4,
          ease: [0.4, 0.0, 0.2, 1],
        }}
        className={clsx(
          className?.replace("animate-slide-up", "") ??
            "fixed inset-0 z-[4000] bg-[#111522] 480:max-w-[440px] 480:mx-auto 480:flex 480:flex-col 480:justify-center"
        )}
      >
        {showCloseIcon && (
          <IoCloseSharp
            onClick={onClose}
            className={clsx(
              "text-3xl font-medium cursor-pointer text-white absolute top-7 right-5 z-[4100]",
              iconClass
            )}
          />
        )}
        {children}
      </motion.div>
    </>
  );
};
